/**
 * Client-side plugin that logs enhanced context for unhandled promise rejections
 * to help with debugging. Sentry enhancement happens in beforeSend hook.
 */
export default defineNuxtPlugin(() => {
  if (process.client) {
    window.addEventListener('unhandledrejection', (event) => {
      // Capture stack trace at the point of rejection
      const capturedStack = new Error('Unhandled rejection context').stack

      // Log enhanced context to console (visible before Sentry processes)
      console.error('🔴 Unhandled Promise Rejection Detected:', {
        // What was rejected
        rejectionType: typeof event.reason,
        rejectionValue: event.reason,
        isError: event.reason instanceof Error,

        // Error details if available
        message: event.reason?.message || String(event.reason),
        stack: event.reason?.stack,

        // Context capture
        capturedStack,
        timestamp: new Date().toISOString(),
        url: window.location.href,

        // Navigation context
        referrer: document.referrer,
      })

      // Note: Sentry enhancement happens in sentry.client.config.ts beforeSend hook
      // instead of mutating event.reason (which is read-only in some browsers)
    })
  }
})
